import React from "react";
import { Edit } from "react-admin";
import { useTranslate } from "react-admin";
import RuleDeemedSupplierForm from "./RuleDeemedSupplierForm";
import { transformData } from "./Services/rulesDeemedSupplierServices";

const RuleDeemedSupplierEdit: React.FC = () => {
  const translate = useTranslate();

  return (
    <Edit
      title={translate("rules.create.title")}
      redirect="list"
      transform={transformData}
    >
      <RuleDeemedSupplierForm />
    </Edit>
  );
};

export default RuleDeemedSupplierEdit;
